import React, { Component } from 'react';
import { NavLink } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import './Activation.css';
import { Auth } from '../../support';

class ConfigActivation extends Component {
  state = {
    data: {},
  };

  constructor(props) {
    super(props);

    const { cliente } = Auth.getData();

    this.state = {
      activation: cliente.config.activation || {},
    };
  }

  getLinkAsForStep(step) {
    const { activation } = this.state;

    let type = activation[step] === true ? 'div' : Link;

    return type;
  }

  getClassNamesForStep(step) {
    const { activation } = this.state;

    let className = activation[step] === true ? 'step complete' : 'step';

    return className;
  }

  render() {
    return (
      <>
        <div className="py-3">
          <strong className="text-info">ACTIVA TU CUENTA</strong>
        </div>

        <div className="py-3">
          <p>
            Al completar el proceso de verificación tendrás acceso a tu Live API Key con la que podrás emitir facturas
            con validez fiscal.
            <br />
            No es necesario completar estos pasos para facturar en modo Test/Sandbox.
          </p>
        </div>

        <div className="activation">
          <div className={this.getClassNamesForStep('email_confirm')}>
            <NavLink
              as={this.getLinkAsForStep('email_confirm')}
              to="/cuenta/config/confirmacion"
            >
              <span className="indicator">1</span>
              <span className="title">Confirma tu correo electrónico </span>
            </NavLink>
          </div>
          <div className={this.getClassNamesForStep('billing_info')}>
            <NavLink
              as={this.getLinkAsForStep('billing_info')}
              to="/cuenta/config/informacion-de-facturacion"
            >
              <span className="indicator">2</span>
              <span className="title">Completa tu información de facturación </span>
            </NavLink>
          </div>
        </div>
      </>
    );
  }
}

export default ConfigActivation;
